import "./Home.module.css";
import GatewayNavigation from "@/reusable_sections/Header";
import CoastalCleaningLlc from "./sections/CoastalCleaningLlc";
import ReadyForAFreshStart from "./sections/ReadyForAFreshStart";
import NuestraSeleccion from "./sections/NuestraSeleccion";
import TheDirectorsPath from "./sections/TheDirectorsPath";
import TheJunkDaddyDifference from "./sections/TheJunkDaddyDifference";
import Testimonials from "./sections/Testimonials";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import FindUsInTheCity from "./sections/FindUsInTheCity";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <GatewayNavigation />
      <CoastalCleaningLlc />
      <ReadyForAFreshStart />
      <NuestraSeleccion />
      <TheDirectorsPath />
      <TheJunkDaddyDifference />
      <Testimonials />
      <FrequentlyAskedQuestions />
      <FindUsInTheCity />
      <Footer />
    </div>;
}